let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aj2IO")).then(() => parcelRequire('cegGR'));